<template>
  <div class="d-flex w-100 h-100 justify-content-center align-items-center">
    <b-badge class="w-100" :variant="color(params.value)">
      {{changesName(params.value)}}
    </b-badge>
    <fa-icon @click="openHistory(params.data)" v-if="(userType === 'ADMIN' || userType === 'VIEWER') && params.colDef.field === 'DoubleChecked' && params.value === true" class="ml-1 w-100" icon="history" />
  </div>
</template>

<script>

import techServiceModule from '@/store/tech-service/techServiceModule'
import { BBadge } from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'cell-renderer-changes',
  components: {
    BBadge
  },
  data () {
    return {
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
    }
  },
  computed: {
    userType () {
      return atob(this.$store.state.user_type)
    },
    changes () {
      return this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].changes
    },
    changesName () {
      return (value) => {
        const index = this.changes.findIndex((e) => e.value === value)
        if (index >= 0) {
          return this.changes[index].label
        }
        return value
      }
    },
    color () {
      return (value) => {
        return (value) ? 'danger' : 'success'
      }
    }
  },
  created() {
    if (!store.hasModule(this.TECH_SERVICE_STORE_MODULE_NAME)) store.registerModule(this.TECH_SERVICE_STORE_MODULE_NAME, techServiceModule)
  },
  methods: {
    openHistory (checkup) {
      this.$vs.loading()
      this.$store.dispatch(this.TECH_SERVICE_STORE_MODULE_NAME + '/getCheckupHistory', checkup._id)
          .then(() => {
            this.$vs.loading.close()
            this.$bvModal.show('modal-checkup-history-classificators')
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })
    },
  }
}
</script>
